export default __webpack_public_path__ + "b540b63ba4c7f12ca8e13674b1bbbf70.svg";